import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { AgitationSection } from './components/AgitationSection';
import { RevelationSection } from './components/RevelationSection';
import { OfferStack } from './components/OfferStack';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-white font-lora selection:bg-brand-red selection:text-white pb-0" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <HookSection data-id="element-4" />
        <AgitationSection data-id="element-5" />
        <RevelationSection data-id="element-6" />
        <OfferStack data-id="element-7" />
        <GuaranteeSection data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>
    </div>;
}